import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// import { IoCallOutline } from "react-icons/io5";
import StudentForm from "../StudentForm";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import "./index.css";

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton> </Modal.Header>
      <Modal.Body>
        <StudentForm />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

const CallRequestModel = () => {
  const { modalShow, setModalShow } = useContext(AppContext);
  return (
    <div>
      {/* <Button className="call-req-button" onClick={() => setModalShow(true)}>
        <IoCallOutline className="phone-icon" /> Book Free Career Counselling
      </Button> */}

      <MyVerticallyCenteredModal
        style={{ zIndex: 10000 }}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

export default CallRequestModel;
